import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import routes from "./constants/routes";
import { GlobalStyle } from "./constants/styles";

import { RecoilRoot } from "recoil";
// import DetailModal from "./components/Modal/DetailModal";

import Home from "./pages/Home";
import Recruit from "./pages/Recruit";
import NotFound from "./pages/NotFound";
import Team from "./pages/Team";
import Project from "./pages/Project";
import ProjectDetail from "./pages/ProjectDetail";

interface AppProps { }

const App: React.FC<AppProps> = () => {
  return (
    <RecoilRoot>
      <GlobalStyle />
      <BrowserRouter>
        <Routes>
          <Route path={routes.HOME} element={<Home />} />
          <Route path={routes.TEAM} element={<Team />} />
          <Route path={routes.RECRUIT} element={<Recruit />} />
          {/* 프로젝트 모달로 띄우기 위해서 하나의 컴포넌트로 매핑 */}
          <Route path={routes.PROJECT} element={<Project />} />
          <Route path={routes.PROJECT_DETAIL} element={<ProjectDetail />} />

          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* <DetailModal /> */}
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
